import { createStyles } from 'antd-style'

export const useFormStyles = createStyles(() => ({
  form: {
    maxHeight: '100%',
    overflowY: 'auto'
  }
}))
